import React, { createContext } from 'react';
import { useSelector } from 'react-redux';
import ProcessIndicator from '~/ui/components/ProcessIndicator/ProcessIndicator';
import { selectProcessIndicator } from '~/reducers/processIndicatorSlice';
import { useUndoRouteEdit } from '~/hooks';

const ProcessIndicatorContext = createContext();

export default ProcessIndicatorContext;

/**
 * Provides the `ProcessIndicatorContext` and also renders the `ProcessIndicator` with the `children`
 */
function ProcessIndicatorProvider({ children }) {
    const processIndicatorInstance = useSelector(selectProcessIndicator);
    const { getUndoButton } = useUndoRouteEdit();
    const undoButton = getUndoButton(processIndicatorInstance.type);

    return (
        <BaseProcessIndicatorProvider>
            {children}
            <ProcessIndicator
                message={processIndicatorInstance.message}
                promiseInProgress={processIndicatorInstance.inProgress}
                promiseRejected={processIndicatorInstance.error}
                position={processIndicatorInstance.position}
                undoButton={undoButton}
            />
        </BaseProcessIndicatorProvider>
    );
}

/**
 * Provides the `ProcessIndicatorContext` without rendering `ProcessIndicator`
 */
export function BaseProcessIndicatorProvider({ children }) {
    const processIndicatorInstance = useSelector(selectProcessIndicator);

    function isProcessIndicatorVisible() {
        return processIndicatorInstance.inProgress;
    }

    return (
        <ProcessIndicatorContext.Provider
            value={{
                isProcessIndicatorVisible,
                processIndicatorType: processIndicatorInstance.type,
                processIndicatorPayload: processIndicatorInstance.payload
            }}
        >
            {children}
        </ProcessIndicatorContext.Provider>
    );
}

export { ProcessIndicatorProvider };
